import React from 'react';
import cn from 'classnames';
import IconUnlock from '@creditflowresearch/uilib/Icon/IconUnlock';
import URL from '@/creditflowresearch/Router/urlConstants';
import { Link } from '@framework/router/Next/Link';

import styles from './styles.module.scss';

const UpgradePlanButton = ({ className = '', dataTest = '' }) => (
  <Link
    dataTest={ dataTest || 'upgradePlanButton' }
    className={ cn(styles.button, className) }
    to={ URL.PRICING }
  >
    Upgrade Plan
    <IconUnlock
      className={ styles.icon }
    />
  </Link>
);

export default UpgradePlanButton;
